import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EMPTY_BOOKED_INSURANCE_LINE_LIST_CRITERIA, EMPTY_CUSTOM_INSURANCE_BOOKED_LIST_CRITERIA, EMPTY_CUSTOM_INSURANCE_EXPORT_RUN_LIST_CRITERIA } from "../constant/customInsuranceBookedConstant";
import { CustomInsuranceAuditLogEntry, CustomInsuranceExportRun } from "../objects/auditLog";
import { CustomInsuranceBookedState } from "../objects/customInsuranceBookedState";
import { BookedInsuranceLineListCriteria, CustomInsuranceBookedListCriteria, CustomInsuranceExportRunListCriteria } from "../objects/customInsuranceBookedTypeList";
import { BookedInsuranceLine } from "../objects/bookedInsuranceLine";

const initialState: CustomInsuranceBookedState = {
    booked_list: [],
    booked_list_loading: false,
    booked_list_criteria: EMPTY_CUSTOM_INSURANCE_BOOKED_LIST_CRITERIA,
    booked_list_count: 0,
    booked_line_list: [],
    booked_line_list_loading: false,
    booked_line_list_criteria: EMPTY_BOOKED_INSURANCE_LINE_LIST_CRITERIA,
    booked_line_list_count: 0,
    export_run_list: [],
    export_run_list_loading: false,
    export_run_list_criteria: EMPTY_CUSTOM_INSURANCE_EXPORT_RUN_LIST_CRITERIA,
    export_run_list_count: 0,
    export_run_refresh: false,
};

const updateBookedListReducer = (state: CustomInsuranceBookedState, action: PayloadAction<CustomInsuranceAuditLogEntry[]>): CustomInsuranceBookedState =>
    ({ ...state, booked_list: action.payload });

const updateBookedListLoadingReducer = (state: CustomInsuranceBookedState, action: PayloadAction<boolean>): CustomInsuranceBookedState =>
    ({ ...state, booked_list_loading: action.payload });

const updateBookedListCriteriaReducer = (state: CustomInsuranceBookedState, action: PayloadAction<CustomInsuranceBookedListCriteria>): CustomInsuranceBookedState =>
    ({ ...state, booked_list_criteria: action.payload });

const updateBookedListCountReducer = (state: CustomInsuranceBookedState, action: PayloadAction<number>): CustomInsuranceBookedState =>
    ({ ...state, booked_list_count: action.payload });

const updateBookedLineListReducer = (state: CustomInsuranceBookedState, action: PayloadAction<BookedInsuranceLine[]>): CustomInsuranceBookedState =>
    ({ ...state, booked_line_list: action.payload });

const updateBookedLineListLoadingReducer = (state: CustomInsuranceBookedState, action: PayloadAction<boolean>): CustomInsuranceBookedState =>
    ({ ...state, booked_line_list_loading: action.payload });

const updateBookedLineListCriteriaReducer = (state: CustomInsuranceBookedState, action: PayloadAction<BookedInsuranceLineListCriteria>): CustomInsuranceBookedState =>
    ({ ...state, booked_line_list_criteria: action.payload });

const updateBookedLineListCountReducer = (state: CustomInsuranceBookedState, action: PayloadAction<number>): CustomInsuranceBookedState =>
    ({ ...state, booked_line_list_count: action.payload });

const updateExportRunListReducer = (state: CustomInsuranceBookedState, action: PayloadAction<CustomInsuranceExportRun[]>): CustomInsuranceBookedState =>
    ({ ...state, export_run_list: action.payload });

const updateExportRunListLoadingReducer = (state: CustomInsuranceBookedState, action: PayloadAction<boolean>): CustomInsuranceBookedState =>
    ({ ...state, export_run_list_loading: action.payload });

const updateExportRunListCriteriaReducer = (state: CustomInsuranceBookedState, action: PayloadAction<CustomInsuranceExportRunListCriteria>): CustomInsuranceBookedState =>
    ({ ...state, export_run_list_criteria: action.payload });

const updateExportRunListCountReducer = (state: CustomInsuranceBookedState, action: PayloadAction<number>): CustomInsuranceBookedState =>
    ({ ...state, export_run_list_count: action.payload });

const toggleExportRunRefreshReducer = (state: CustomInsuranceBookedState): CustomInsuranceBookedState =>
    ({ ...state, export_run_refresh: !state.export_run_refresh });

export const customInsuranceBooked = createSlice({
    name: 'custom_insurance_booked',
    initialState,
    reducers: {
        updateBookedList: updateBookedListReducer,
        updateBookedListLoading: updateBookedListLoadingReducer,
        updateBookedListCriteria: updateBookedListCriteriaReducer,
        updateBookedListCount: updateBookedListCountReducer,
        updateBookedLineList: updateBookedLineListReducer,
        updateBookedLineListLoading: updateBookedLineListLoadingReducer,
        updateBookedLineListCriteria: updateBookedLineListCriteriaReducer,
        updateBookedLineListCount: updateBookedLineListCountReducer,
        updateExportRunList: updateExportRunListReducer,
        updateExportRunListLoading: updateExportRunListLoadingReducer,
        updateExportRunListCriteria: updateExportRunListCriteriaReducer,
        updateExportRunListCount: updateExportRunListCountReducer,
        toggleExportRunRefresh: toggleExportRunRefreshReducer,
    },
});

export const {
    updateBookedList,
    updateBookedListLoading,
    updateBookedListCriteria,
    updateBookedListCount,
    updateBookedLineList,
    updateBookedLineListLoading,
    updateBookedLineListCriteria,
    updateBookedLineListCount,
    updateExportRunList,
    updateExportRunListLoading,
    updateExportRunListCriteria,
    updateExportRunListCount,
    toggleExportRunRefresh,
} = customInsuranceBooked.actions;
